module.exports = __webpack_public_path__ + "img/art.dee876b1.png";